konnyScript(function($){
    

    /* 주의사항 펼침 기능 */
    $('.bwWrap .conWrap .notiBox .notiTit').click(function(){
        var notiBox = $(this).parent('.notiBox');
        notiBox.toggleClass('on');
    });
    
    //Tab Slide
    var bwNavSlide = new Swiper("#bw_nav_swiper_slide1", {
        slidesPerView:'auto',
        grabCursor:true,
        centeredSlides:false,
    });

    //Tab Scroll
    (function () {
    	const $tabs = $('.bwWrap .navWrap li');
    	const sections = [...Array(9)].map((_, i) => $('#bwCon' + (i + 1)));
    	const isMobile = () => $(window).width() <= 750;
    
    	let isFromClick = false;
    	let clickTimeout;
    
    	$('#bw_nav_swiper_slide1 a').on('click', function (e) {
    		e.preventDefault();
    		const $li = $(this).closest('li');
    		const index = $li.index();
    
    		clearTimeout(clickTimeout);
    		isFromClick = true;
    		clickTimeout = setTimeout(() => { isFromClick = false; }, 600);
    
    		$li.addClass('on').siblings().removeClass('on');
    		bwNavSlide.slideTo(index);
    
    		const headerHeight = $('#header').outerHeight() || 0;
    		const navHeight = $('.bwWrap .navWrap').outerHeight() || 0;
    		const fixHeight = headerHeight + navHeight;
    		const targetSection = $('#bwCon' + (index + 1));
    
            if (targetSection.length) {
            	const targetTop = targetSection.offset().top - fixHeight + 50;
            
            	if (window.scrollY === 0) {
            		$('.bwWrap .navWrap').addClass('fixed');
            
            		window.scrollTo({ top: 1 });
            		setTimeout(() => {
            			window.scrollTo({ top: targetTop });
            		}, 20);
            	} else {
            		window.scrollTo({ top: targetTop });
            	}
            }
    
    		if (isMobile()) {
    			const container = bwNavSlide.el;
    			const containerWidth = $(container).width();
    			const wrapper = $(container).find('.swiper-wrapper');
    			const slideOffset = $li.position().left;
    			const slideWidth = $li.outerWidth(true);
    			const totalSlides = $tabs.length;
    			let scrollX = 0;
    
    			if (index <= 1) {
    				scrollX = 0;
    			} else if (index >= 2 && index <= 5) {
    				scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
    			} else {
    				const $last = $tabs.last();
    				const lastOffset = $last.position().left;
    				const lastWidth = $last.outerWidth(true);
    				scrollX = (lastOffset + lastWidth) - containerWidth;
    			}
    			wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
    		}
    	});
    
    	$(window).on('load scroll', function () {
    		if (!$('.bwWrap .navWrap').length || isFromClick) return;
    
    		const headerHeight = $('#header').outerHeight() || 0;
    		const navHeight = $('.bwWrap .navWrap').outerHeight() || 0;
    		const fixHeight = headerHeight + navHeight;
    		const winTop = $(window).scrollTop();
    		const bwNavTop = $('.bwWrap .navArea').offset().top - navHeight;
    
    		let activeIndex = 0;
    
    		for (let i = sections.length - 1; i >= 0; i--) {
    			if (winTop > sections[i].offset().top - fixHeight) {
    				activeIndex = i;
    				break;
    			}
    		}
    
    		if (winTop > bwNavTop) {
    			$('.bwWrap .navWrap').addClass('fixed');
    		} else {
    			$('.bwWrap .navWrap').removeClass('fixed');
    		}
    
    		const $activeTab = $tabs.eq(activeIndex);
    		$activeTab.addClass('on').siblings().removeClass('on');
    		bwNavSlide.slideTo(activeIndex);
    
    		if (isMobile()) {
    			const container = bwNavSlide.el;
    			const containerWidth = $(container).width();
    			const wrapper = $(container).find('.swiper-wrapper');
    			const slideOffset = $activeTab.position().left;
    			const slideWidth = $activeTab.outerWidth(true);
    			const totalSlides = $tabs.length;
    			let scrollX = 0;
    
    			if (activeIndex <= 1) {
    				scrollX = 0;
    			} else if (activeIndex >= 2 && activeIndex <= 5) {
    				scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
    			} else {
    				const $last = $tabs.last();
    				const lastOffset = $last.position().left;
    				const lastWidth = $last.outerWidth(true);
    				scrollX = (lastOffset + lastWidth) - containerWidth;
    			}
    			wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
    		}
    	});
    })();

})